import { inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { BootcampService } from '@api-client';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BootCampStore {
  private readonly bootCampService = inject(BootcampService);

  private id = signal<string | null>(null);

  setId(newId: string) {
    this.id.set(newId);
  }

  $bootCamp = rxResource({
    request: () => this.id(),
    loader: ({ request }) =>
      request
        ? this.bootCampService.bootcampControllerFindById({ id: request })
        : of(null),
  });

  bootCamp = this.$bootCamp.value;

  refresh = () => {
    this.$bootCamp.reload();
  };
}
